import Button, { ButtonProps } from "domains/ui/components/Button";
import Icon from "domains/ui/components/Icon";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "domains/ui/components/Modal";

import { Box, Text, VStack } from "@chakra-ui/react";

interface ModalEnhanceSelectProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalEnhanceSelect({
  isOpen,
  onClose,
}: ModalEnhanceSelectProps) {
  return (
    <Modal closeOnEsc isOpen={isOpen} onClose={onClose} variant="modern">
      <ModalOverlay />
      <ModalContent maxW="400px" p={0} bgColor="backgroundTertiary.500">
        <ModalCloseButton />
        <ModalBody p={0} w="full">
          <Box
            w="full"
            px={4}
            py={3}
            textAlign="left"
            borderColor="border.500"
            borderBottomWidth="1px"
          >
            <Text size="body.bold.lg">What Do You Want To Enhance?</Text>
          </Box>

          <VStack align="stretch" w="full" p={4} spacing={2}>
            <SelectButton
              leftIcon={<Icon id="Nav/Image/Outline" h="14px" />}
              internalLink="/enhance"
              onClick={onClose}
            >
              Images
            </SelectButton>

            <SelectButton
              leftIcon={<Icon id="Nav/Video/Outline" h="11px" />}
              internalLink="/videos/enhance"
              onClick={onClose}
            >
              Videos
            </SelectButton>

            {/* <SelectButton leftIcon={<Icon id="Nav/3D/Outline" h="14px" />}
              onClick={onClose}>
              3D
            </SelectButton> */}

            <SelectButton
              leftIcon={<Icon id="Nav/Texture/Outline" h="14px" />}
              internalLink="/textures/enhance"
              onClick={onClose}
            >
              Textures
            </SelectButton>

            <SelectButton
              leftIcon={<Icon id="Nav/Skybox/Outline" h="14px" />}
              internalLink="/skyboxes/enhance"
              onClick={onClose}
            >
              Skyboxes
            </SelectButton>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

// ------------------------------------

function SelectButton(props: ButtonProps) {
  return (
    <Button size="sm" variant="secondary" {...props} justifyContent="left" />
  );
}
